module.exports = __webpack_public_path__ + "fonts/montserrat-extrabold-webfont.2dce32e.woff2";